export default __webpack_public_path__ + "static/media/ic_new_link_16.33dcae6c.svg";